import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import Reservation from '@/views/reservation/Reservation.vue'
import ReservationComplate from '@/views/reservation/ReservationComplete.vue'
import PrivacyPolicyPage from '@/views/privacy-policy/PrivacyPolicyPage.vue'
import ReservationConfirm from '@/views/reservation/ReservationConfirm.vue'

Vue.use(VueRouter)

export enum RouteName {
  RESERVATION = 'Reservation',
  RESERVATION_CONFIRM = 'ReservationConfirm',
  RESERVATION_COMPLETE = 'ReservationComplete',
  ERROR = 'Error',
  PRIVACY_POLICY = 'PrivacyPolicy'
}

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  },
  {
    path: '/404',
    component: () =>
      import(/* webpackChunkName: '404' */ '@/views/error/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '/error',
    component: Reservation,
    children: [
      {
        path: '',
        component: () => import('@/views/error/ErrorPage.vue'),
        props: (route: Route) => ({ error: route.params.error }),
        name: RouteName.ERROR
      }
    ]
  },
  {
    path: '/',
    component: Reservation,
    name: RouteName.RESERVATION,
    props: true
  },
  {
    path: '/confirm',
    component: ReservationConfirm,
    name: RouteName.RESERVATION_CONFIRM,
    props: { reservationForm: {} }
  },
  {
    path: '/complete',
    component: ReservationComplate,
    name: RouteName.RESERVATION_COMPLETE
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicyPage,
    name: RouteName.PRIVACY_POLICY
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
